// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/source-map-loader/dist/cjs.js!../../node_modules/tailwindcss/base.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/source-map-loader/dist/cjs.js!../../node_modules/tailwindcss/components.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/source-map-loader/dist/cjs.js!../../node_modules/tailwindcss/utilities.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/source-map-loader/dist/cjs.js!./fonts.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/source-map-loader/dist/cjs.js!../../node_modules/katex/dist/katex.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/source-map-loader/dist/cjs.js!../../node_modules/@mdxeditor/editor/dist/style.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg width=%27100%25%27 height=%27100%25%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3crect width=%27100%25%27 height=%27100%25%27 fill=%27none%27 rx=%2712%27 ry=%2712%27 stroke=%27%2300C9B2FF%27 stroke-width=%274%27 stroke-dasharray=%27130%2c 60%27 stroke-dashoffset=%270%27 stroke-linecap=%27butt%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer base {
    body {
        @apply font-main text-layout-textcolor bg-bodyBackground text-body;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-smoothing: antialiased;
        overflow-x: hidden;
    }

    h1 {
        @apply text-h1 font-h1 leading-h1 mt-1 sm:mt-3 mb-2;
    }

    h2 {
        @apply text-h2 font-h2 leading-h2 mt-1 sm:mt-3 mb-2;
    }

    h3 {
        @apply text-h3 font-h3 leading-h3 mt-1 sm:mt-3 mb-2;
    }

    h4 {
        @apply text-h4 font-h4 leading-h4 mt-2 mb-1;
    }

    h5 {
        @apply text-h5 font-h5 leading-h5 mt-1 mb-1;
    }

    h6 {
        @apply text-h6 font-h6 leading-h6 mt-1 mb-1;
    }

    .p,
    p {
        @apply text-body leading-body mb-2;
    }

    strong {
        @apply font-bold;
    }

    a {
        @apply underline hover:text-primary;
    }

    hr {
        @apply my-3;
    }

    code {
        @apply text-[12px] sm:text-[14px];
    }

    .boxOld {
        @apply bg-white rounded-xl shadow-xl p-[35px] overflow-x-auto;
    }

    .box {
        @apply bg-config-boxBackgroundColor rounded-xl p-8 shadow-lg mb-4;
    }

    table:not(.chattable) {
        @apply w-full overflow-hidden border-collapse border-none;
    }

    table:not(.chattable) th,
    table:not(.chattable) td {
        @apply py-2 text-left;
    }

    table:not(.chattable) th {
        @apply font-bold text-left;
    }

    ol {
        @apply list-decimal pb-0 sm:pb-2 px-3 sm:ml-[5px];
    }

    ul {
        @apply list-disc py-1 sm:py-2 px-3 sm:ml-[5px];
    }

    li {
        @apply my-1 sm:my-2 leading-body;
    }

    ul p,
    ol p {
        @apply mt-0 mb-0;
    }

    .container {
        @apply m-auto max-w-[1000px] w-full;
    }

    .demo-dashed-border {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    }

    .navigationheader-icon-display {
        display: theme('colors.navHeader-icon-display');
    }

    .navigationheader-icon-padding {
        padding-left: theme('colors.navHeader-icon-padding');
    }

    .tremor-daterangepicker {
        @apply shadow-none;
    }

    .tremor-daterangepicker p {
        margin: 0;
        font-size: inherit;
        line-height: inherit;
    }

    .tremor-daterangepicker th {
        @apply !text-center;
    }

    .tremor-daterangepicker td {
        @apply !py-1;
    }

    .tremor-daterangepicker .aria-selected\\:text-tremor-content-inverted[aria-selected='true'] {
        @apply !text-primary !bg-gray-100;
    }

    .tremor-daterangepicker button {
        @apply !text-layout-textColorOnPrimary;
    }

    .tremor-daterangepicker button[disabled] {
        @apply !text-gray-200;
    }

    .tremor-daterangepicker button {
        @apply border-layout-borderColor;
    }

    .apexcharts-tooltip {
        @apply !text-layout-textcolor !bg-config-boxBackgroundColor !border-layout-borderColor;
    }

    .apexcharts-tooltip .apexcharts-tooltip-title {
        @apply !text-layout-textcolor !bg-config-boxBackgroundColor !border-layout-borderColor;
    }

    .chartText {
        @apply fill-layout-textcolor mb-2;
    }

    .apexcharts-xaxistooltip-bottom {
        @apply !hidden;
    }

    @keyframes pulse {
        0% {
            transform: scale(0.5);
            opacity: 0;
        }
        50% {
            opacity: 1;
        }
        100% {
            transform: scale(1.2);
            opacity: 0;
        }
    }

    .icon-pulse {
        animation: pulse 2s infinite;
    }

    .mathOld {
        @apply text-text;
        @apply inline-block;
    }

    math {
        @apply text-layout-textcolor;
        @apply inline-block;
    }

    .mathOld * {
        @apply text-text;
    }

    math * {
        @apply text-layout-textcolor;
    }

    .dashboard-date-picker * {
        @apply text-layout-textcolor;
    }

    .tremor-daterangepicker button {
        @apply !text-layout-textcolor hover:bg-datePickerSelectedColor;
    }

    .dashboard-date-picker > div:nth-child(3) button {
        @apply bg-primary !text-button-primary-outline-text-hover;
    }

    .tremor-daterangepicker .aria-selected\\:text-tremor-content-inverted[aria-selected='true'] {
        @apply !bg-datePickerSelectedColor;
    }

    .tremor-daterangepicker button[disabled] {
        @apply !text-gray-500;
    }

    .react-joyride__tooltip {
        @apply !bg-joyride-backgroundColor !text-joyride-textColor;
    }

    .react-joyride__tooltip h3 {
        @apply text-joyride-headlineColor;
    }

    .react-joyride__tooltip button[data-test-id='button-skip'] {
        @apply !text-joyride-textColor;
    }

    .__floater__arrow span svg polygon {
        @apply !fill-joyride-backgroundColor;
    }

    .katex {
        @apply !inline-block;
    }

    .katex-display {
        @apply mt-0 mb-2 text-left;
    }

    ::-webkit-scrollbar {
        width: 7px;
        background-color: transparent;
    }

    /* Farbe des Scrollbalkens */
    ::-webkit-scrollbar-thumb {
        @apply bg-gray-500;
        border-radius: 7px;
    }

    /* Hover-Effekt */
    ::-webkit-scrollbar-thumb:hover {
        @apply bg-gray-500;
    }

    /* Scrollbar bei aktiven Elementen */
    ::-webkit-scrollbar-thumb:active {
        @apply bg-gray-500;
    }

    scrollbar-width: thin;
    scrollbar-color: theme('colors.gray.500') transparent;
}

.katex {
    display: block;
}
`, "",{"version":3,"sources":["webpack://./src/styles/dark_roesler.css"],"names":[],"mappings":"AAQA;IACI;QACI,kEAAkE;QAClE,kCAAkC;QAClC,mCAAmC;QACnC,2BAA2B;QAC3B,kBAAkB;IACtB;;IAEA;QACI,mDAAmD;IACvD;;IAEA;QACI,mDAAmD;IACvD;;IAEA;QACI,mDAAmD;IACvD;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;;QAEI,kCAAkC;IACtC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,6DAA6D;IACjE;;IAEA;QACI,iEAAiE;IACrE;;IAEA;QACI,yDAAyD;IAC7D;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,iDAAiD;IACrD;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,gCAAgC;IACpC;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,yDAAsT;IAC1T;;IAEA;QACI,+CAA+C;IACnD;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,SAAS;QACT,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,sFAAsF;IAC1F;;IAEA;QACI,sFAAsF;IAC1F;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI;YACI,qBAAqB;YACrB,UAAU;QACd;QACA;YACI,UAAU;QACd;QACA;YACI,qBAAqB;YACrB,UAAU;QACd;IACJ;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,4BAA4B;QAC5B,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8DAA8D;IAClE;;IAEA;QACI,yDAAyD;IAC7D;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,0DAA0D;IAC9D;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,6BAA6B;IACjC;;IAEA,4BAA4B;IAC5B;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA,iBAAiB;IACjB;QACI,kBAAkB;IACtB;;IAEA,oCAAoC;IACpC;QACI,kBAAkB;IACtB;;IAEA,qBAAqB;IACrB,qDAAqD;AACzD;;AAEA;IACI,cAAc;AAClB","sourcesContent":["@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n\n@import './fonts.css';\n@import 'katex/dist/katex.min.css';\n@import '../../node_modules/@mdxeditor/editor/dist/style.css';\n\n@layer base {\n    body {\n        @apply font-main text-layout-textcolor bg-bodyBackground text-body;\n        -moz-osx-font-smoothing: grayscale;\n        -webkit-font-smoothing: antialiased;\n        font-smoothing: antialiased;\n        overflow-x: hidden;\n    }\n\n    h1 {\n        @apply text-h1 font-h1 leading-h1 mt-1 sm:mt-3 mb-2;\n    }\n\n    h2 {\n        @apply text-h2 font-h2 leading-h2 mt-1 sm:mt-3 mb-2;\n    }\n\n    h3 {\n        @apply text-h3 font-h3 leading-h3 mt-1 sm:mt-3 mb-2;\n    }\n\n    h4 {\n        @apply text-h4 font-h4 leading-h4 mt-2 mb-1;\n    }\n\n    h5 {\n        @apply text-h5 font-h5 leading-h5 mt-1 mb-1;\n    }\n\n    h6 {\n        @apply text-h6 font-h6 leading-h6 mt-1 mb-1;\n    }\n\n    .p,\n    p {\n        @apply text-body leading-body mb-2;\n    }\n\n    strong {\n        @apply font-bold;\n    }\n\n    a {\n        @apply underline hover:text-primary;\n    }\n\n    hr {\n        @apply my-3;\n    }\n\n    code {\n        @apply text-[12px] sm:text-[14px];\n    }\n\n    .boxOld {\n        @apply bg-white rounded-xl shadow-xl p-[35px] overflow-x-auto;\n    }\n\n    .box {\n        @apply bg-config-boxBackgroundColor rounded-xl p-8 shadow-lg mb-4;\n    }\n\n    table:not(.chattable) {\n        @apply w-full overflow-hidden border-collapse border-none;\n    }\n\n    table:not(.chattable) th,\n    table:not(.chattable) td {\n        @apply py-2 text-left;\n    }\n\n    table:not(.chattable) th {\n        @apply font-bold text-left;\n    }\n\n    ol {\n        @apply list-decimal pb-0 sm:pb-2 px-3 sm:ml-[5px];\n    }\n\n    ul {\n        @apply list-disc py-1 sm:py-2 px-3 sm:ml-[5px];\n    }\n\n    li {\n        @apply my-1 sm:my-2 leading-body;\n    }\n\n    ul p,\n    ol p {\n        @apply mt-0 mb-0;\n    }\n\n    .container {\n        @apply m-auto max-w-[1000px] w-full;\n    }\n\n    .demo-dashed-border {\n        background-image: url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%2300C9B2FF' stroke-width='4' stroke-dasharray='130%2c 60' stroke-dashoffset='0' stroke-linecap='butt'/%3e%3c/svg%3e\");\n    }\n\n    .navigationheader-icon-display {\n        display: theme('colors.navHeader-icon-display');\n    }\n\n    .navigationheader-icon-padding {\n        padding-left: theme('colors.navHeader-icon-padding');\n    }\n\n    .tremor-daterangepicker {\n        @apply shadow-none;\n    }\n\n    .tremor-daterangepicker p {\n        margin: 0;\n        font-size: inherit;\n        line-height: inherit;\n    }\n\n    .tremor-daterangepicker th {\n        @apply !text-center;\n    }\n\n    .tremor-daterangepicker td {\n        @apply !py-1;\n    }\n\n    .tremor-daterangepicker .aria-selected\\:text-tremor-content-inverted[aria-selected='true'] {\n        @apply !text-primary !bg-gray-100;\n    }\n\n    .tremor-daterangepicker button {\n        @apply !text-layout-textColorOnPrimary;\n    }\n\n    .tremor-daterangepicker button[disabled] {\n        @apply !text-gray-200;\n    }\n\n    .tremor-daterangepicker button {\n        @apply border-layout-borderColor;\n    }\n\n    .apexcharts-tooltip {\n        @apply !text-layout-textcolor !bg-config-boxBackgroundColor !border-layout-borderColor;\n    }\n\n    .apexcharts-tooltip .apexcharts-tooltip-title {\n        @apply !text-layout-textcolor !bg-config-boxBackgroundColor !border-layout-borderColor;\n    }\n\n    .chartText {\n        @apply fill-layout-textcolor mb-2;\n    }\n\n    .apexcharts-xaxistooltip-bottom {\n        @apply !hidden;\n    }\n\n    @keyframes pulse {\n        0% {\n            transform: scale(0.5);\n            opacity: 0;\n        }\n        50% {\n            opacity: 1;\n        }\n        100% {\n            transform: scale(1.2);\n            opacity: 0;\n        }\n    }\n\n    .icon-pulse {\n        animation: pulse 2s infinite;\n    }\n\n    .mathOld {\n        @apply text-text;\n        @apply inline-block;\n    }\n\n    math {\n        @apply text-layout-textcolor;\n        @apply inline-block;\n    }\n\n    .mathOld * {\n        @apply text-text;\n    }\n\n    math * {\n        @apply text-layout-textcolor;\n    }\n\n    .dashboard-date-picker * {\n        @apply text-layout-textcolor;\n    }\n\n    .tremor-daterangepicker button {\n        @apply !text-layout-textcolor hover:bg-datePickerSelectedColor;\n    }\n\n    .dashboard-date-picker > div:nth-child(3) button {\n        @apply bg-primary !text-button-primary-outline-text-hover;\n    }\n\n    .tremor-daterangepicker .aria-selected\\:text-tremor-content-inverted[aria-selected='true'] {\n        @apply !bg-datePickerSelectedColor;\n    }\n\n    .tremor-daterangepicker button[disabled] {\n        @apply !text-gray-500;\n    }\n\n    .react-joyride__tooltip {\n        @apply !bg-joyride-backgroundColor !text-joyride-textColor;\n    }\n\n    .react-joyride__tooltip h3 {\n        @apply text-joyride-headlineColor;\n    }\n\n    .react-joyride__tooltip button[data-test-id='button-skip'] {\n        @apply !text-joyride-textColor;\n    }\n\n    .__floater__arrow span svg polygon {\n        @apply !fill-joyride-backgroundColor;\n    }\n\n    .katex {\n        @apply !inline-block;\n    }\n\n    .katex-display {\n        @apply mt-0 mb-2 text-left;\n    }\n\n    ::-webkit-scrollbar {\n        width: 7px;\n        background-color: transparent;\n    }\n\n    /* Farbe des Scrollbalkens */\n    ::-webkit-scrollbar-thumb {\n        @apply bg-gray-500;\n        border-radius: 7px;\n    }\n\n    /* Hover-Effekt */\n    ::-webkit-scrollbar-thumb:hover {\n        @apply bg-gray-500;\n    }\n\n    /* Scrollbar bei aktiven Elementen */\n    ::-webkit-scrollbar-thumb:active {\n        @apply bg-gray-500;\n    }\n\n    scrollbar-width: thin;\n    scrollbar-color: theme('colors.gray.500') transparent;\n}\n\n.katex {\n    display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
